import React from "react"
import {graphql} from "gatsby"
import { StickyContainer } from 'react-sticky'

import Layout from "../components/layout"
import SEO from "../components/seo"
import MenySection from "../components/menySection"

import {find,sortBy} from 'lodash'

class Premium extends React.Component {
  render(){
    const menuCategories = this.props.data.allContentfulMenyKategorier.edges;
    const dishes = sortBy(this.props.data.allContentfulMatratt.edges, dish => dish.node.number);

    let sortedCategories = [];
    let groupedDishes = {};
    dishes.forEach(dish => {

      if (dish.node.type === 'premium') {
        if (!groupedDishes[dish.node.category.id]) {
          groupedDishes[dish.node.category.id] = [];
        }
        // if the last element is not the same then add it
        if (sortedCategories.length===0 || sortedCategories.slice(-1)[0].node.id !== dish.node.category.id) {
          const dishCategory = find(menuCategories,cat => cat.node.id === dish.node.category.id);
          sortedCategories.push( dishCategory );
        }
        groupedDishes[dish.node.category.id].push(dish.node);
      }
    });

    return (
      <Layout>
        <SEO title="Premium Meny" />
        <StickyContainer className="menu-outer">
          {sortedCategories.map(menuCategory => {
            return (
              <MenySection menuCategory={menuCategory} groupedDishes={groupedDishes} />
            );
          })}
        </StickyContainer>
      </Layout>
    );
  }
}

export default Premium

export const pageQuery = graphql`
query{
  allContentfulMenyKategorier(limit: 1000) {
    edges {
      node {
        id
        name
        backgroundImage{
          file { url }
          fluid(maxWidth: 1600) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        defaultPrices
        sushi
      }
    }
  }
  allContentfulMatratt(
    limit: 1000
    sort: {
      fields: [number]
      order: ASC
    }
  ) {
    edges {
      node {
        id
        number
        title
        type
        description
        spiciness
        image{
          file { url }
          fluid(maxWidth: 1600) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        prices
        category{
          id
        }
      }
    }
  }
}
`
